import { ButtonProps, CleanButton } from 'src/common/components/Button';
import styled from 'styled-components';
import { ReactComponent as CloseSvg } from 'src/assets/icons/close.svg';

import { rgba } from 'polished';
import { FC } from 'react';

const Button = styled(CleanButton)`
  height: 2.5rem;
  width: 2.5rem;
  transition: background 0.2s ease;
  background-color: ${({ theme }) => rgba(theme.colors.grey2, 0.2)};
  border-radius: 0.5rem;

  &:hover &:not(:disabled) {
    background-color: ${({ theme }) => rgba(theme.colors.grey2, 0.6)};
  }
`;

export interface ScreenScrapeCloseButtonProps extends ButtonProps {
  onClose: () => void;
}

export const ScreenScrapeCloseButton: FC<ScreenScrapeCloseButtonProps> = ({
  onClose,
  ...props
}) => {
  return (
    <Button onClick={onClose} {...props}>
      <CloseSvg />
    </Button>
  );
};
